// extracted by mini-css-extract-plugin
export default {"break-point-md":"40rem","break-point-lg":"60rem","wrapper":"Popup_wrapper__5i0y8","show":"Popup_show__2EbIj","popup":"Popup_popup__71Aws","popup__icon":"Popup_popup__icon__e93Ab"};